import { ComponentProps } from "react";
import { UseFormReturn, Path } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { WriteQuestionnaire } from "@/types/questionnaire";
import { isDateExpired } from "@/lib/isDateExpired";
import Field from "@/components/Field";
import { QuestionnaireWarningAlert } from "./QuestionnaireWarningAlert";

interface QuestionnaireExpiredDateWarningFieldProps
  extends Omit<ComponentProps<typeof Field>, "name"> {
  name: Path<WriteQuestionnaire>;
  form: UseFormReturn<WriteQuestionnaire>;
}

export function QuestionnaireExpiredDateWarningField({
  name,
  form,
  ...fieldProps
}: QuestionnaireExpiredDateWarningFieldProps) {
  const { t } = useTranslation();
  const isExpired = isDateExpired(form.watch(name));

  return (
    <div className="space-y-2">
      <Field name={name} {...fieldProps} />
      {isExpired && (
        <QuestionnaireWarningAlert
          message={t("questionnaires.warnings.expiredDocument")}
        />
      )}
    </div>
  );
}
